import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NsValidators } from '../../../common/shared/ns-validators'
import { UserAccountsService } from '../../../common/user-accounts/user-accounts.service';
import { UserService } from '../../../core/services/user.service';
import { FormSupportService } from '../../../core/services/form-support.service';
import { HeadlessView } from '../../../common/shared/components/headless-view';
import { LayoutService } from '../../../common/layout/layout.service';
import { MobileDetectorService } from '../../../common/shared/mobile-detector.service';
import { ContactsAppService } from '../contacts-app.service'

@Component({
    selector: 'ns-contact-form',
    templateUrl: './contact-form.component.html',
    styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent extends HeadlessView implements OnInit, OnDestroy {

    public subscription: Subscription = new Subscription();

    public id: any;
    public form: FormGroup = this.formBuilder.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        email: ['', Validators.required],
        companyName: [''],
        phone: ['', NsValidators.simplePhoneValidator],
    });

    constructor(
        protected layoutService: LayoutService,
        protected mobileDetectorService: MobileDetectorService,
        private formBuilder: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private contactsAppService: ContactsAppService,
        private userService: UserService,
        private formSupport: FormSupportService
    ) {
        super(layoutService, mobileDetectorService);

        this.layoutService.enableFooter();

        const contactData = activatedRoute.snapshot.data.contact
        if (contactData) {
            this.id = contactData && contactData.id;
            this.form.patchValue(contactData)
        }
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.subscription.unsubscribe();
    }

    onSubmit() {
        if (this.id) {
            this.formSupport.formSubmitHelper(
              this.form,
              this.contactsAppService.editContact,
              [this.id, this.form.value]
            ).then(offer => {
                this.router.navigate(['..'], { relativeTo: this.activatedRoute });
            }).catch(err => {});

        } else {
            this.formSupport.formSubmitHelper(
              this.form,
              this.contactsAppService.addContact,
              [this.form.value]
            ).then(offer => {
                this.router.navigate(['..'], { relativeTo: this.activatedRoute });
            }).catch(err => {});
        }
    }

}
